module.exports = __webpack_public_path__ + "static/media/Kled_0.a98bfb31.jpg";